// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/sun.js';

import { paths } from '../generated/sun';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('sun', Original, paths);
